export const SET_TRIGGERS_RANGE_FILTER = 'SET_TRIGGERS_RANGE_FILTER';

export const setTriggersRangeFilter = range => ({
  type: SET_TRIGGERS_RANGE_FILTER,
  data: range,
});
